
import React from 'react';
import { commonOverlayStyle } from './overlayStyles';

const FullscreenReminder = ({ enterFullScreen, timeElapsed }) => {
  // Format time elapsed
  const minutes = Math.floor(timeElapsed / 60);
  const seconds = timeElapsed % 60 < 10 ? `0${timeElapsed % 60}` : timeElapsed % 60;
  
  return (
    <div style={commonOverlayStyle}>
      <h3>Please switch to fullscreen mode to continue.</h3>
      <div style={{
        marginTop: 10,
        color: '#fff',
        fontSize: '16px',
        fontStyle: 'italic'
      }}>
        Failure to enter fullscreen mode may impact your scorecard assessment.*
      </div>
      <div 
        onClick={enterFullScreen} 
        style={{ 
          background: '#fff', 
          padding: '6px 20px', 
          borderRadius: 6, 
          color: '#000', 
          fontSize: 14, 
          cursor: 'pointer' 
        }}
      >
        Go Fullscreen
      </div>
      <div style={{
        marginTop: 20,
        color: '#fff',
        fontSize: '18px'
      }}>
        Time Elapsed: {minutes}:{seconds}
      </div>
    </div>
  );
};

export default FullscreenReminder;